<template>
  <div class="policy-container">
    <div v-html="content" v-if="content"></div>
    <no-data v-else-if="isError"></no-data>
  </div>
</template>

<script>
import { getDetail } from '@/api/policy';
import noData from '@/components/noData/index';
export default {
  data() {
    return {
      id: '',
      title: '',
      content: null,
      isError: false,
    };
  },
  components: { noData },
  created() {
    this.id = this.$route.query.id || this.$route.params.id;
    this.title = this.$route.query.title ? decodeURIComponent(this.$route.query.title) : null;
    if (this.title) {
      document.title = this.title;
    }
  },

  async mounted() {
    await this.getDetail();
  },
  methods: {
    //获取详情数据
    getDetail() {
      if (!this.id) {
        return;
      }
      const params = {
        id: Number(this.id),
      };
      getDetail(params)
        .then(res => {
          console.log(res);
          if (res && res.code==200 && res.data) {
            this.isError = false;
            if (res.data.url) {
              document.title = res.data.url;
            }

            this.content = res.data.content ? decodeURIComponent(res.data.content) : null;
          } else {
            this.isError = true;
          }
        })
        .catch(() => {
          this.isError = true;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.policy-container {
  width: 100%;
  height: 100%;
  overflow: auto;
  word-break: break-all;
  white-space: pre-wrap;
  padding: 15px;
  box-sizing: border-box;
  img {
    max-width: 100%;
  }
}
</style>
